export default function FacebookLogo(props: React.ComponentProps<"svg">) {
    return (
        <svg
            viewBox="0 0 9 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.7" clipPath="url(#clip0_1173_3310)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.88603 9.28378V18.1903C1.88603 18.3198 1.98737 18.4212 2.11686 18.4212H5.42163C5.55112 18.4212 5.65246 18.3198 5.65246 18.1903V9.1374H8.05082C8.16905 9.1374 8.27039 9.04732 8.28165 8.92346L8.51247 6.19857C8.52373 6.06345 8.41676 5.94522 8.28165 5.94522H5.65246V4.00852C5.65246 3.55249 6.01841 3.18655 6.47443 3.18655H8.32105C8.45054 3.18655 8.55188 3.08521 8.55188 2.95572V0.230828C8.55188 0.101339 8.45054 0 8.32105 0H5.19644C3.37234 0 1.88603 1.4863 1.88603 3.31604V5.94522H0.230828C0.101339 5.94522 0 6.04656 0 6.17605V8.90094C0 9.03043 0.101339 9.13177 0.230828 9.13177H1.88603V9.27814V9.28378Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1173_3310">
                    <rect
                        width="8.55751"
                        height="18.4212"
                        fill="currentColor"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
